/**
 * Centralized zIndex constants for React Flow nodes, edges, and CSS elements.
 *
 * React Flow zIndex values control the rendering order of nodes and edges.
 * CSS zIndex values control the stacking order of UI elements.
 */

// React Flow Node zIndex values
export const NODE_Z_INDEX_GROUP = 0; // Group nodes
export const NODE_Z_INDEX_BASE = 0; // Regular nodes, ghost nodes, drop zone nodes
export const NODE_Z_INDEX_HIGHLIGHTED = 3; // Highlighted regular/group label/standalone nodes
export const NODE_Z_INDEX_DRAGGING = 1000; // Nodes being dragged
export const NODE_Z_INDEX_CREATING = 1000; // Nodes being created (sections, text nodes)

export const NODE_Z_INDEX_GROUP_LABEL = 1; // Group label nodes
export const NODE_Z_INDEX_GROUP_OVERLAY = 9999; // Group overlay nodes

export const NODE_Z_INDEX_TEXT = 10; // Text nodes
export const NODE_Z_INDEX_STICKY_NOTE = 10; // Sticky note nodes
export const NODE_Z_INDEX_STANDALONE = 1; // Standalone nodes
export const NODE_Z_INDEX_SECTION = 0; // Section nodes

// React Flow Edge zIndex values
export const EDGE_Z_INDEX_DEFAULT = 1; // Default edges
export const EDGE_Z_INDEX_HIGHLIGHTED = 2; // Highlighted edges

// CSS zIndex values
export const CSS_Z_INDEX_PREVIEW_OVERLAY = 12; // Preview overlay
export const CSS_Z_INDEX_CANVAS_CONTROLS = 10; // Canvas controls
export const CSS_Z_INDEX_NODE_HANDLE = 1000; // Text/sticky note/section node handles
export const CSS_Z_INDEX_SWAP_OVERLAY = 1; // SweepNodeComponent swap overlay
export const CSS_Z_INDEX_CREATE_ELEMENT_CURSOR = 1000; // CreateFreeElementTool cursor
